/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AdminInviteApiDto, AdminInviteDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAdminInviteController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-admin-invite-controller
   * @name UpdateInvite
   * @request PUT:/api/v1/onboarding/admin-invite/{inviteId}
   */
  updateInvite = (inviteId: string, data: AdminInviteApiDto, params: RequestParams = {}) =>
    this.http.request<AdminInviteDto, any>({
      path: `/v1/onboarding/admin-invite/${inviteId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateInvitePath = '/v1/onboarding/admin-invite/${inviteId}'
  static updateInviteMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-admin-invite-controller
   * @name DeleteInvite
   * @request DELETE:/api/v1/onboarding/admin-invite/{inviteId}
   */
  deleteInvite = (inviteId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/onboarding/admin-invite/${inviteId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteInvitePath = '/v1/onboarding/admin-invite/${inviteId}'
  static deleteInviteMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-admin-invite-controller
   * @name GetInvites
   * @request GET:/api/v1/onboarding/admin-invite
   */
  getInvites = (params: RequestParams = {}) =>
    this.http.request<AdminInviteDto[], any>({
      path: `/v1/onboarding/admin-invite`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInvitesPath = '/v1/onboarding/admin-invite'
  static getInvitesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-admin-invite-controller
   * @name CreateInvite
   * @request POST:/api/v1/onboarding/admin-invite
   */
  createInvite = (data: AdminInviteApiDto, params: RequestParams = {}) =>
    this.http.request<AdminInviteDto, any>({
      path: `/v1/onboarding/admin-invite`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createInvitePath = '/v1/onboarding/admin-invite'
  static createInviteMethod = 'POST'
}
